import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { WdxButtonDirective } from './wdx-button.directive';

@NgModule({
    declarations: [WdxButtonDirective],
    exports: [WdxButtonDirective],
    imports: [CommonModule],
})
export class WdxButtonModule {}
